<template>
  <ul>
    <li class="dropdown-item">
      <router-link :to="addToQuery({ page: 1, parent_id: folder.id, 'filters[versions_id_not_null]': true })" class="dropdown-item">
        {{ $t('root.filters.yes_more_versions') }}
      </router-link>
    </li>
    <li class="dropdown-item">
      <router-link :to="addToQuery({ page: 1, parent_id: folder.id, 'filters[versions_id_not_null]': false })" class="dropdown-item">
        {{ $t('root.filters.no_more_versions') }}
      </router-link>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      folder: {
        type: Object,
        required: true,
      },
    },
  }
</script>
